import { useState, useEffect } from "react";
import API from "../API";


const useProcuringEntityPackage = (packageId, startTime, endTime) => {
  const [procuringEntityPackage, setProcuringEntityPackage] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const [challengesImplementations, setChallengesImplementations] = useState(
    []
  );
  const [incidentAndAccidents, setIncidentAndAccidents] = useState([]);
  const [statusRelocation, setStatusRelocation] = useState([]);
  const [enviromentalSafeguards, setEnviromentalSafeguards] = useState([]);
  const [socialSafeguardsData, setSocialSafeguardsData] = useState([]);
  const [contractInfo, setContractInfo] = useState([]);
  const [grievances, setGrievances] = useState([]);
  const [problemsConstraints] = useState([]);
  const [financialStatus, setFinancialStatus] = useState([]);
  const [reportSummaryInfo] = useState([]);
  const [subprojects, setSubprojects] = useState([]); 

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        setLoading(true);
        const res = await API.getPackage(packageId, startTime, endTime);
        setProcuringEntityPackage(res.data);
        setChallengesImplementations(res.data.package_challenges);
        setIncidentAndAccidents(res.data.package_incidents);
        setStatusRelocation(res.data.package_relocated_utilities);
        setEnviromentalSafeguards(res.data.package_environmental_safeguards);
        setSocialSafeguardsData(res.data.package_social_safeguards);
        setContractInfo(res.data);
        setFinancialStatus(res.data.financial_statuses);
        setEquipments(res.data.equipments);
        setGrievances(res.data.procuring_entity_package_grievances)
        setStaff(res.data.staffs);
        try {
          const spRes = await API.getSubProjects({ "filter[procuring_entity_package_id]": packageId });
          const list = Array.isArray(spRes?.data?.data) ? spRes?.data?.data : [];
          const filtered = list.filter((sp) => Number(sp?.alias_for || 0) === 0);
          setSubprojects(filtered);
        } catch (e) {
          const payloadList = Array.isArray(res?.data?.sub_projects) ? res.data.sub_projects : [];
          const filteredPayload = payloadList.filter((sp) => Number(sp?.alias_for || 0) === 0);
          setSubprojects(filteredPayload);
        }
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch package", err);
        setError(err);
        setLoading(false);
      }
    };

    fetchPackage();
  }, [packageId, startTime, endTime]);

  return {
    procuringEntityPackage,
    equipments,
    grievances,
    staff,
    financialStatus,
    contractInfo,
    challengesImplementations,
    problemsConstraints,
    incidentAndAccidents,
    statusRelocation,
    enviromentalSafeguards,
    socialSafeguardsData,
    reportSummaryInfo,
    subprojects,
    loading,
    error,
  };
};

export default useProcuringEntityPackage;
